module.exports = __webpack_public_path__ + "img/ic-edit.a692fb06.svg";